import React, { useCallback, useEffect, useState } from 'react';
import { Table, Tag , Tooltip, Input, Button, Row, Col, message, Divider, List, Skeleton, Pagination } from 'antd';
import axios from "axios"
import moment from "moment"
// import { requestError } from '../controllers/functions';
import  { QuestionCircleOutlined } from "@ant-design/icons";
// import DatePickerComponent from '../components/date/period';
import { debounce } from "lodash"
import { Link } from "react-router-dom";
import DatePickerComponent from '../../components/date/period';
import { requestError } from '../../controllers/functions';

const BillingMessagesPage = () => {
    return <>
      <Messages/>
    </>
};
export default BillingMessagesPage;

const Messages = () => {

  const [data, setData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [reportPeriod, setReportPeriod] = useState([
    moment().startOf("month").toDate(),
    moment().toDate(),
  ]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(2);
  const [searchString, setSearchString] = useState(null);
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    try {

      const [ startDate, endDate ] = reportPeriod;

      const filters = {
        startDate,
        endDate,
        currentPage,
        pageSize
      }

      const q = {
        ...filters,
        ...(searchString?
        { searchString } : {})
      }

      const queryParams = new URLSearchParams(q).toString(q);
      const url = process.env.REACT_APP_API_URI+`/sms/billing?${queryParams}`;

      setLoading(true);
      const { data } = await axios.get(url, {headers: { authorization : `Bearer ${localStorage.getItem("token")}`}});

      const { messages, totalMessages } = data;

      setTotalRows(totalMessages)

      setData(
          messages.map( ({messageText, id : key, messageDate, status, totalSmsUnits, messageReference, destination  }) => ({
            key,
            messageDate : moment(messageDate).format("ddd[,] DD MMM YYYY HH:mm"), 
            status : (
                <Tag color={ status === 'sent' ? 'green' : 'red'}>{status?.toUpperCase()}</Tag>
            ), 
            totalSmsUnits : (<>
            {totalSmsUnits} {" "}
            <Tooltip placement="bottom" title={`One message has 160 characters`} color={"#87d068"} key={key}>
                <QuestionCircleOutlined />
            </Tooltip>
            </>), 
            messageReference, 
            destination, 
            totalCharacters : messageText?.length,
            messageText : ( <div style={{ textWrap : "wrap", minWidth : 350, maxWidth:500 }}>
                {messageText}
            </div>)
        }))
      )

    } catch (error) {
      requestError(error);
    } finally {
      setLoading(false);
    }
  },[currentPage, pageSize, reportPeriod, searchString])

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <h3>Messages</h3>
        <div>
          <Input
            style={{ height: 29, width : 250 }}
            placeholder="Search..."
            onChange={(v) => {
              setCurrentPage(1);
              setSearchString(v.target.value);
            }}
          />
        </div>
      </div>

      <div>
        <DatePickerComponent
          showIcon={false}
          style={{
            height: 29,
            marginRight: 5,
            marginBottom: "0.5rem"
          }}
          reportPeriod={reportPeriod}
          setReportPeriod={(v) => {
            setReportPeriod(v);
            setCurrentPage(1);
          }}
        />
      </div>

      <Divider/>

      <List
        className="demo-loadmore-list"
        loading={loading}
        itemLayout="horizontal"
        dataSource={data}
        renderItem={(item) => (
          <List.Item>
            <Skeleton avatar title={false} loading={loading} active>
              <List.Item.Meta
                title={
                  <Link to="#" style={{ fontSize: 13 }}>
                    {item.messageDate}{" "}
                    -{" "}
                    {item.destination}
                  </Link>
                }
                description={
                  <div style={{ color: "#888" }}>
                    <div style={{ 
                      fontSize: 14,
                      marginBottom: "0.5rem",
                      wordBreak : "break-word"
                      }}>{item.messageText}</div>
                    <div style={{ fontSize: 13, display : "flex", gap : 10 }}>
                      <span>
                        <span style={{ fontWeight: 600 }}>Status:</span>{" "}
                        <span>
                          {item.status}
                        </span>
                      </span>
                      <span>
                        <span style={{ fontWeight: 600 }}>Characters:</span>{" "}
                        {item?.totalCharacters}
                      </span>

                      <span>
                        <span style={{ fontWeight: 600 }}>Sms Count:</span>{" "}
                        <span>
                          {item.totalSmsUnits}
                        </span>
                      </span>

                     
                      
                    </div>
                  </div>
                }
              />
            </Skeleton>
          </List.Item>
        )}
      />

      {totalRows > pageSize && (
        <Pagination
          current={currentPage}
          pageSize={pageSize}
          total={totalRows}
          onChange={(pg) => setCurrentPage(pg)}
          showSizeChanger={false}
          style={{ marginTop: 20, textAlign: "center" }}
        />
      )}
    </>
  );
};